<template>
  <div class="okrcadastro">
    <loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
    <div class="container">
      <ol class="breadcrumb-arrow">
        <li>
          <a href="/home"><i class="fa fa-home"></i></a>
          <a href="/okr">OKRs</a>
        </li>
        <li>
          <a href="#">{{title}}</a>
        </li>
      </ol>
    </div>

    <div class="container mt-2">
      <div class="card">
        <form class="ml-3 mt-3 mr-3 mb-3">
          <div class="col-md-12">
            <a-steps :current="current" size="small">
              <a-step v-for="item in steps" :key="item.title" :title="item.title" />
            </a-steps>

            <div class="steps-content">
              <br />

              <!-- STEP 0 — DADOS GERAIS -->
              <div class="row d-flex justify-content-center" v-if="current == 0">
                <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">

                  <!-- TÍTULO (linha inteira) -->
                  <label for="inputTitulo">
                    Título do Objetivo
                    <el-tooltip content="Campo obrigatório" placement="top">
                      <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                    </el-tooltip>
                  </label>
                  <div class="input-group">
                    <div class="input-group-prepend mb-2">
                      <span class="input-group-text"><i class="fas fa-bullseye"></i></span>
                    </div>
                    <input id="inputTitulo" type="text" maxlength="300"
                      class="form-control mb-2"
                      v-model="okr.descricao"
                      placeholder="Informe o título do objetivo estratégico"/>
                  </div>

                  <!-- TIPO e DATA FIM lado a lado -->
                  <div class="row">
                    <div class="col-md-6">
                      <label for="selectTipo">
                        Tipo
                        <el-tooltip content="Campo obrigatório" placement="top">
                          <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                        </el-tooltip>
                      </label>
                      <div class="input-group">
                        <div class="input-group-prepend mb-2">
                          <span class="input-group-text"><i class="fas fa-tag"></i></span>
                        </div>
                        <select id="selectTipo" class="form-control mb-2" v-model="okr.tipo">
                          <option value="">Selecione</option>
                          <option v-for="t in listaTipo" :key="t.codigo" :value="t.codigo">{{t.descricao}}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <label for="dataFim">
                        Data Fim
                        <el-tooltip content="Campo obrigatório" placement="top">
                          <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                        </el-tooltip>
                      </label>
                      <div class="input-group">
                        <div class="input-group-prepend mb-2">
                          <span class="input-group-text"><i class="far fa-calendar-alt"></i></span>
                        </div>
                        <flat-picker id="dataFim" class="form-control datepicker mb-2"
                          placeholder="Data de encerramento"
                          v-model="okr.dataFim"
                          :config="{ allowInput: true, dateFormat: 'd/m/Y', altFormat: 'M j, Y' }" />
                      </div>
                    </div>
                  </div>

                  <!-- Situação: exibida apenas na edição -->
                  <div class="row" v-if="okr.idokr">
                    <div class="col">
                      <label for="selectSituacao">Situação</label>
                      <div class="input-group">
                        <div class="input-group-prepend mb-2">
                          <span class="input-group-text"><i class="fas fa-traffic-light"></i></span>
                        </div>
                        <select id="selectSituacao" class="form-control mb-2" v-model="okr.situacao">
                          <option v-for="s in listaSituacao" :key="s.codigo" :value="s.codigo">{{s.descricao}}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- STEP 1 — INDICADORES / KRs -->
              <div class="row d-flex justify-content-center" v-if="current == 1">
                <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                  <label>Indicadores / Resultados-Chave (KRs):
                    <el-tooltip content="Ao menos um indicador é necessário" placement="top">
                      <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                    </el-tooltip>
                  </label>

                  <div class="mt-1" style="background-color: WhiteSmoke">
                    <div class="row ml-2 mr-2 mt-2 mb-2 p-2"
                      style="border: 1px solid #dee2e6; border-radius: 4px; background: #fff;"
                      v-for="(ind, idx) in okr.listaIndicador" :key="idx">
                      <div class="col-10">
                        <strong>{{ mascaraKr(okr, idx) }} - {{ ind.descricao }}</strong><br/>
                        <small class="text-muted">
                          Baseline: <b>{{ ind.baseline }}</b> &nbsp;|&nbsp;
                          Meta: <b>{{ ind.meta }}</b>
                          <span v-if="ind.tipoIndicador"> &nbsp;|&nbsp; Tipo: <b>{{ tipoIndicadorLabel(ind.tipoIndicador) }}</b></span>
                          <span v-if="ind.sentido"> &nbsp;|&nbsp;
                            <i :class="ind.sentido === 'MAIORMELHOR' ? 'fas fa-arrow-up text-success' : 'fas fa-arrow-down text-info'"></i>
                            {{ ind.sentido === 'MAIORMELHOR' ? 'Maior é melhor' : 'Menor é melhor' }}
                          </span>
                          <br/>
                          <i :class="ind.situacao === 'EM_ANDAMENTO' ? 'fas fa-play-circle text-info' : (ind.situacao === 'ALCANCADO' ? 'fas fa-check-circle text-success' : (ind.situacao === 'CANCELADO' ? 'fas fa-ban text-danger' : 'fas fa-pause-circle text-secondary'))"></i>
                          Situação: <b>{{ ind.situacao === 'EM_ANDAMENTO' ? 'Em andamento' : (ind.situacao === 'ALCANCADO' ? 'Alcançado' : (ind.situacao === 'CANCELADO' ? 'Cancelado' : 'Não iniciado')) }}</b>
                        </small>
                      </div>
                      <div class="col-2 text-right" v-if="!ind.idindicador">
                        <el-tooltip style="cursor:pointer" content="Editar Indicador" placement="top">
                          <i class="fas fa-edit text-info mr-2 mt-1" @click="editarIndicador(idx)"></i>
                        </el-tooltip>
                        <el-tooltip style="cursor:pointer" content="Remover Indicador" placement="top">
                          <i class="fas fa-trash text-danger mt-1" @click="retirarIndicador(idx)"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <div class="text-center">
                    <el-tooltip content="Adicionar Indicador/KR" placement="top">
                      <button type="button" class="btn btn-primary" @click="addIndicador()">
                        <i class="fas fa-plus-circle mr-2"></i>Adicionar Indicador
                      </button>
                    </el-tooltip>
                  </div>
                </div>
              </div>


              <!-- STEP 2 — GRUPO DE TRABALHO -->
              <div class="row d-flex justify-content-center" v-if="current == 2">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-8">
                  <label>Grupo de Trabalho do Objetivo:
                    <el-tooltip content="Ao menos um Grupo de Trabalho é necessário" placement="top">
                      <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                    </el-tooltip>
                  </label>
                  <div class="mt-1" style="background-color: WhiteSmoke">
                    <div class="row ml-4" v-if="okr.grupoTrabalho">
                      <div class="col-10 mt-1 mb-2">
                        {{ okr.grupoTrabalho.nomeComCoord || (okr.grupoTrabalho.coordenacao ? (okr.grupoTrabalho.coordenacao.sigla + ' - ' + okr.grupoTrabalho.nome) : okr.grupoTrabalho.nome) }}
                      </div>
                    </div>
                    <div v-else class="p-3 text-muted text-center">
                      Nenhum Grupo de Trabalho selecionado.
                    </div>
                  </div>
                  <br/>
                  <div class="text-center">
                    <el-tooltip :content="okr.grupoTrabalho ? 'Trocar Grupo de Trabalho' : 'Selecionar Grupo de Trabalho'" placement="top">
                      <button type="button" class="btn btn-primary" @click="addGrupoTrabalho()">
                        <i :class="okr.grupoTrabalho ? 'fas fa-exchange-alt mr-2' : 'fas fa-plus-circle mr-2'"></i>
                        <span v-if="!okr.grupoTrabalho">Selecionar</span>
                        <span v-else>Trocar</span>
                      </button>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <!-- STEP 3 — RESPONSÁVEIS -->
              <div class="row d-flex justify-content-center" v-if="current == 3">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-8">
                  <label>Responsável(is) pelo Objetivo:
                    <el-tooltip content="Ao menos um responsável é necessário" placement="top">
                      <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
                    </el-tooltip>
                  </label>
                  <div class="mt-1" style="background-color: WhiteSmoke">
                    <div class="row ml-4" v-for="usuario in okr.listaResp" :key="usuario.idusuario">
                      <div class="col-10 mt-1 mb-2">{{ usuario.nome }} ({{usuario.apelido}})</div>
                      <div class="col-1 text-center">
                        <el-tooltip style="cursor:pointer" content="Retirar Responsável" placement="top">
                          <i class="fas fa-trash mt-2 text-danger" @click="retirarResp(usuario.idusuario)"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <div class="text-center">
                    <el-tooltip content="Adicionar Responsável ao Objetivo" placement="top">
                      <button type="button" class="btn btn-primary" @click="addResponsavel()">
                        <i class="fas fa-plus-circle mr-2"></i>Adicionar
                      </button>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <!-- STEP 4 — PROJETOS -->
              <div class="row d-flex justify-content-center" v-if="current == 4">
                <div class="col-lg-8 col-md-8 col-sm-10 col-xs-12">
                  <label>Projeto(s) Vinculado(s):</label>
                  <div class="mt-1" style="background-color: WhiteSmoke">
                    <div class="row ml-4" v-for="proj in okr.listaProjeto" :key="proj.idprojeto">
                      <div class="col-10 mt-1 mb-2">{{ proj.codigoNome || (proj.codigo + ' - ' + proj.titulo) }}</div>
                      <div class="col-1 text-center">
                        <el-tooltip style="cursor:pointer" content="Retirar Projeto" placement="top">
                          <i class="fas fa-trash mt-2 text-danger" @click="retirarProjeto(proj.idprojeto)"></i>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                  <br/>
                  <div class="text-center">
                    <el-tooltip content="Vincular Projeto" placement="top">
                      <button type="button" class="btn btn-primary" @click="addProjeto()">
                        <i class="fas fa-plus-circle mr-2"></i>Adicionar Projeto
                      </button>
                    </el-tooltip>
                  </div>
                </div>
              </div>

              <!-- STEP 5 — RESUMO -->
              <div class="row d-flex justify-content-center" v-if="current == 5">
                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-12">
                  <div class="row">
                    <div class="col-lg-3 font-weight-bold text-right">Descrição:</div>
                    <div class="col-lg-9 text-left">{{okr.descricao}}</div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-lg-3 font-weight-bold text-right">Tipo:</div>
                    <div class="col-lg-9 text-left">{{okr.tipo}}</div>
                  </div>
                  <div class="row mt-1" v-if="okr.idokr">
                    <div class="col-lg-3 font-weight-bold text-right">Situação:</div>
                    <div class="col-lg-9 text-left">{{okr.situacao}}</div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-lg-3 font-weight-bold text-right">Data Fim:</div>
                    <div class="col-lg-9 text-left">{{okr.dataFim}}</div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-lg-3 font-weight-bold text-right">Grupo de Trabalho:</div>
                    <div class="col-lg-9 text-left">
                      {{ okr.grupoTrabalho ? (okr.grupoTrabalho.nomeComCoord || (okr.grupoTrabalho.coordenacao ? (okr.grupoTrabalho.coordenacao.sigla + ' - ' + okr.grupoTrabalho.nome) : okr.grupoTrabalho.nome)) : '--' }}
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-lg-3 font-weight-bold text-right">Indicadores/KRs:</div>
                    <div class="col-lg-9 text-left" style="background-color: whitesmoke;">
                      <div v-for="(ind, idx) in okr.listaIndicador" :key="idx" style="border: 1px solid #dee2e6; background-color: #FFF; margin-top: 1px; margin-bottom: 1px; border-radius: 5px; padding: 4px 6px;">
                        <strong>{{ mascaraKr(okr, idx) }} - {{ ind.descricao }}</strong><br/>
                        <small class="text-muted">
                          Baseline: {{ ind.baseline }} &nbsp;|&nbsp; Meta: {{ ind.meta }}
                          <span v-if="ind.tipoIndicador"> &nbsp;|&nbsp; Tipo: <b>{{ tipoIndicadorLabel(ind.tipoIndicador) }}</b></span>
                          <span v-if="ind.sentido"> &nbsp;|&nbsp;
                            <i :class="ind.sentido === 'MAIORMELHOR' ? 'fas fa-arrow-up text-success' : 'fas fa-arrow-down text-info'"></i>
                            {{ ind.sentido === 'MAIORMELHOR' ? 'Maior é melhor' : 'Menor é melhor' }}
                          </span>
                          &nbsp;|&nbsp;
                          <i :class="ind.situacao === 'EM_ANDAMENTO' ? 'fas fa-play-circle text-info' : (ind.situacao === 'ALCANCADO' ? 'fas fa-check-circle text-success' : (ind.situacao === 'CANCELADO' ? 'fas fa-ban text-danger' : 'fas fa-pause-circle text-secondary'))"></i>
                          Situação: <b>{{ ind.situacao === 'EM_ANDAMENTO' ? 'Em andamento' : (ind.situacao === 'ALCANCADO' ? 'Alcançado' : (ind.situacao === 'CANCELADO' ? 'Cancelado' : 'Não iniciado')) }}</b>
                        </small>
                      </div>
                      <span v-if="!okr.listaIndicador || okr.listaIndicador.length == 0" class="text-muted">Nenhum indicador adicionado</span>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-lg-3 font-weight-bold text-right">Responsável(is):</div>
                    <div class="col-lg-9 text-left">
                      <div v-for="resp in okr.listaResp" :key="resp.idusuario">{{resp.nome}}</div>
                    </div>
                  </div>
                  <div class="row mt-1">
                    <div class="col-lg-3 font-weight-bold text-right">Projeto(s):</div>
                    <div class="col-lg-9 text-justify">
                      <div v-for="proj in okr.listaProjeto" :key="proj.idprojeto">{{proj.codigoNome || (proj.codigo + ' - ' + proj.titulo)}}</div>
                      <span v-if="!okr.listaProjeto || okr.listaProjeto.length == 0" class="text-muted">Nenhum projeto vinculado</span>
                    </div>
                  </div>
                </div>
              </div>

            </div><!-- /steps-content -->

            <!-- BOTÕES DE NAVEGAÇÃO -->
            <div class="steps-action w-100 text-center mt-4">

              <el-tooltip style="margin-left:8px" content="Passo anterior" placement="top" v-if="current > 0">
                <span>
                  <button type="button" class="btn btn-info" @click="anterior">
                    <i class="fas fa-angle-double-left"></i> Anterior
                  </button>
                </span>
              </el-tooltip>

              <el-tooltip style="margin-left:8px" content="Cancelar" placement="top">
                <span>
                  <button type="button" class="btn btn-danger" @click="voltar()">
                    <i class="fa fa-times"></i> Cancelar
                  </button>
                </span>
              </el-tooltip>

              <el-tooltip style="margin-left:8px" content="Próximo passo" placement="top" v-if="current < steps.length - 1">
                <span>
                  <button type="button" class="btn btn-info" @click="proximo">
                    <i class="fas fa-angle-double-right"></i> Próximo
                  </button>
                </span>
              </el-tooltip>

              <el-tooltip style="margin-left:8px" content="Salvar Objetivo" placement="top" v-if="current == steps.length - 1">
                <span>
                  <button type="button" class="btn btn-success" @click="salvarOkr()">
                    <i class="fas fa-bullseye mr-2"></i>
                    <span v-if="!okr.idokr">Cadastrar Objetivo</span>
                    <span v-if="okr.idokr">Alterar Objetivo</span>
                  </button>
                </span>
              </el-tooltip>

            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- MODAL ADICIONAR / EDITAR INDICADOR -->
    <modal :show.sync="modals.modalIndicador" modal-classes="modal-dialog-scrollable">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">{{ indicadorEdicao.idx !== null ? 'Editar' : 'Adicionar' }} Indicador</h4>
        <div class="row">
          <div class="col-md-12">
            <label for="indDescricao">
              Título
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input id="indDescricao" ref="indDescricaoInput" type="text" class="form-control mb-2" v-model="indicadorEdicao.descricao" maxlength="300" placeholder="Descreva o resultado-chave"/>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="indBaseline">
              Baseline <small class="text-muted">(valor inicial)</small>
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input id="indBaseline" type="number" step="any" class="form-control mb-2" v-model="indicadorEdicao.baseline" placeholder="0"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46 || event.charCode == 45"/>
          </div>
          <div class="col-md-6">
            <label for="indMeta">
              Meta
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <input id="indMeta" type="number" step="any" class="form-control mb-2" v-model="indicadorEdicao.meta" placeholder="100"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46 || event.charCode == 45"/>
          </div>
        </div>
        <!-- Novos campos: Tipo e Sentido -->
        <div class="row">
          <div class="col-md-6">
            <label for="indTipo">
              Tipo
              <el-tooltip content="Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <select id="indTipo" class="form-control mb-2" v-model="indicadorEdicao.tipoIndicador">
              <option value="">Selecione</option>
              <option v-for="t in listaTipoIndicador" :key="t.codigo" :value="t.codigo">{{t.descricao}}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label for="indSentido">
              Sentido
              <el-tooltip content="Indica se atingir um valor maior ou menor significa progresso. Campo obrigatório" placement="top">
                <i style="font-size:12px" class="fas fa-exclamation-circle text-info ml-1"></i>
              </el-tooltip>
            </label>
            <select id="indSentido" class="form-control mb-2" v-model="indicadorEdicao.sentido">
              <option value="">Selecione</option>
              <option v-for="s in listaSentidoIndicador" :key="s.codigo" :value="s.codigo">{{s.descricao}}</option>
            </select>
          </div>
        </div>
        <!-- Fonte (opcional) -->
        <div class="row">
          <div class="col-md-12">
            <label for="indFonte">Fonte de Verificação</label>
            <input id="indFonte" type="text" class="form-control mb-2" v-model="indicadorEdicao.fonte" maxlength="2000" placeholder="Ex: Planilha de monitoramento, Sinan. Ano-base..."/>
          </div>
        </div>
        <!-- Forma de Cálculo (opcional) -->
        <div class="row">
          <div class="col-md-12">
            <label for="indFormaCalculo">Forma de Cálculo</label>
            <textarea id="indFormaCalculo" class="form-control mb-2" rows="3" maxlength="4000"
              v-model="indicadorEdicao.formaCalculo" placeholder="Descreva como o indicador é calculado (opcional)"></textarea>
            <div class="text-right">
              <small class="text-muted">{{ (indicadorEdicao.formaCalculo || '').length }}/4000</small>
            </div>
          </div>
        </div>
        <!-- Situação inicial do KR -->
        <div class="row mt-2 mb-3">
          <div class="col-md-12 d-flex align-items-center">
            <label class="mb-0 mr-3">Situação inicial do KR</label>
            <div class="custom-control custom-switch">
              <input type="checkbox" class="custom-control-input" id="situacaoKrSwitch"
                v-model="indicadorEdicao.situacao"
                true-value="EM_ANDAMENTO" false-value="NAO_INICIADO" style="cursor: pointer;">
              <label class="custom-control-label font-weight-bold" for="situacaoKrSwitch" style="cursor: pointer;">
                {{ indicadorEdicao.situacao === 'EM_ANDAMENTO' ? 'Em andamento' : 'Não iniciado' }}
              </label>
            </div>
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button type="button" class="btn btn-success mr-2" @click="confirmarIndicador()">
            <i class="fas fa-check mr-1"></i> Confirmar
          </button>
          <button type="button" class="btn btn-danger" @click="fecharModalIndicador()">
            Cancelar
          </button>
        </div>
      </form>
    </modal>

    <!-- MODAL SELECIONAR GRUPO DE TRABALHO -->
    <modal :show.sync="modals.modalGT">
      <loader object="#df3e46" v-show="progressGT" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0" objectbg="#0d0c0d" opacity="50" name="circular"></loader>
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Selecionar Grupo de Trabalho</h4>
        <div class="row">
          <div class="col input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="addGTNome"
              placeholder="Pesquisar por nome" @keyup="pesquisarGT()"/>
          </div>
        </div>
        <div style="height:200px; border:1px dashed #c0c0c0; overflow:auto">
          <div v-if="listaAddGT.length === 0" class="text-center text-muted p-3">
            Nenhum grupo de trabalho encontrado.
          </div>
          <div v-for="gt in listaAddGT" :key="gt.idgt">
            <div class="listaGT gtInfo" @click="selecionarGT(gt)">
              {{ gt.nomeComCoord || (gt.coordenacao ? (gt.coordenacao.sigla + ' - ' + gt.nome) : gt.nome) }}
              <i class="fas fa-check text-muted opcao mr-3"></i>
            </div>
          </div>
        </div>
        <br class="clear"/>
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-secondary ml-4" @click="fecharModalGT()">Fechar</button>
        </div>
      </form>
    </modal>

    <!-- MODAL ADICIONAR RESPONSÁVEL -->
    <modal :show.sync="modals.modalResp">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Incluir Responsável</h4>
        <div class="row">
          <div class="col input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control mb-2" v-model="addRespNome"
              placeholder="Pesquisar por nome" @keyup="pesquisarResp()"/>
          </div>
        </div>
        <div style="height:200px; border:1px dashed #c0c0c0; overflow:auto">
          <div class="listaGT" v-for="resp in listaAddResp" :key="resp.idusuario">
            <div class="gtInfo" @click="adicionarResp(resp)">
              {{ resp.nome }} ({{resp.apelido}})
              <i class="fas fa-plus text-muted opcao mr-3"></i>
            </div>
          </div>
        </div>
        <br class="clear"/>
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-danger ml-4" @click="fecharModalResp()">Desistir</button>
        </div>
      </form>
    </modal>

    <!-- MODAL ADICIONAR PROJETO -->
    <modal :show.sync="modals.modalProjeto" size="lg">
      <form class="ml-3 mt-3 mr-3 mb-3">
        <h4 class="text-center">Vincular Projeto</h4>
        <div class="row">
          <div class="col input-group">
            <div class="input-group-prepend mb-2">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" ref="addProjNomeInput" class="form-control mb-2" v-model="addProjNome"
              :disabled="progressVinculoProjeto"
              placeholder="Pesquisar por nome ou código" @keyup="pesquisarProjeto()"/>
          </div>
        </div>
        <div style="height:250px; border:1px dashed #c0c0c0; overflow:auto">
          <div v-if="addProjNome.length < 3 && !progressVinculoProjeto" class="text-center text-muted p-3">
            <i class="fas fa-search mr-1"></i> Digite ao menos 3 caracteres para pesquisar.
          </div>
          <div v-else-if="progressVinculoProjeto" class="text-center text-muted p-3">
            <i class="fas fa-spinner fa-spin mr-1"></i> Pesquisando...
          </div>
          <div v-else-if="listaAddProj.length === 0 && addProjNome.length >= 3" class="text-center text-muted p-3">
            Nenhum projeto encontrado.
          </div>
          <div class="listaGT" v-for="proj in listaAddProj" :key="proj.idprojeto">
            <div class="gtInfo" @click="adicionarProjeto(proj)" style="align-items: flex-start;">
              <span style="flex: 1; word-break: break-word; white-space: normal;">{{ proj.codigoNome || (proj.codigo + ' - ' + proj.titulo) }}</span>
              <i class="fas fa-plus text-muted opcao mr-3 mt-1" style="flex-shrink: 0;"></i>
            </div>
          </div>
        </div>
        <br class="clear"/>
        <div class="col-md-12 text-center mt-3">
          <button type="button" class="btn btn-secondary ml-4" @click="fecharModalProjeto()">Fechar</button>
        </div>
      </form>
    </modal>

  </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  props: {
    idokr: { type: String }
  },
  components: { flatPicker },
  created() {
    this.carregarTela();
  },
  data() {
    return {
      title: "Incluir Objetivo",
      current: 0,
      steps: [
        { title: "Dados Gerais" },
        { title: "Indicadores (KRs)" },
        { title: "Grupo de Trabalho" },
        { title: "Responsável(is)" },
        { title: "Projeto(s)" },
        { title: "Resumo" },
      ],
      progress: false,
      progressGT: false,
      progressVinculoProjeto: false,
      okr: {
        idokr: null,
        descricao: "",
        dataFim: null,
        tipo: "",
        situacao: "",
        idgt: null,
        grupoTrabalho: null,
        listaIndicador: [],
        listaResp: [],
        listaProjeto: [],
      },
      listaTipo: [],
      listaSituacao: [],
      listaTipoIndicador: [],
      listaSentidoIndicador: [],
      addGTNome: "",
      listaAddGT: [],
      listaAddGTFiltro: [],
      addRespNome: "",
      listaAddResp: [],
      listaAddRespFiltro: [],
      addProjNome: "",
      listaAddProj: [],
      listaAddProjFiltro: [],
      indicadorEdicao: { idx: null, descricao: "", baseline: null, meta: null, tipoIndicador: "", sentido: "", fonte: "", formaCalculo: "", situacao: "NAO_INICIADO" },
      modals: {
        modalGT: false,
        modalIndicador: false,
        modalResp: false,
        modalProjeto: false,
      },
      userId: Number(localStorage.getItem("idusuario")),
      perfilAdmin: localStorage.getItem("pnome") === "ADMIN",
      perfilNome: localStorage.getItem("pnome") || "",
      idCoordenacao: null,
    };
  },
  methods: {
    carregarTela() {
      this.carregarEnums();
      if (this.idokr) {
        this.title = "Alterar Objetivo";
        this.carregarInfoUsuario();
        this.carregarOkr(this.idokr);
      } else {
        this.carregarUsuarioAtual();
      }
    },
    carregarInfoUsuario() {
      // Carrega dados do usuário logado para uso no filtro de GT (apenas coordenação)
      this.$clubApi.get("/user/info").then((response) => {
        let usuario = response.data.object;
        if (usuario && usuario.grupoTrabalho && usuario.grupoTrabalho.coordenacao) {
          this.idCoordenacao = usuario.grupoTrabalho.coordenacao.idcoordenacao;
        }
      });
    },
    carregarUsuarioAtual() {
      this.progress = true;
      this.$clubApi.get("/user/info").then( (response) => {
        let usuario = response.data.object;
        if (usuario && usuario.grupoTrabalho) {
          this.idCoordenacao = usuario.grupoTrabalho.coordenacao ? usuario.grupoTrabalho.coordenacao.idcoordenacao : null;
          this.okr.idgt = usuario.grupoTrabalho.idgt;
          this.okr.grupoTrabalho = usuario.grupoTrabalho;
        }
        this.okr.listaResp.push(usuario);
      }).finally(() => {
        this.progress = false;
      });
    },
    carregarEnums() {
      this.$clubApi.get("/enum/tipoOkr").then((r) => { this.listaTipo = r.data.object; });
      this.$clubApi.get("/enum/situacaoOkr").then((r) => { this.listaSituacao = r.data.object; });
      this.$clubApi.get("/enum/tipoIndicadorOkr").then((r) => { this.listaTipoIndicador = r.data.object; });
      this.$clubApi.get("/enum/sentidoIndicador").then((r) => { this.listaSentidoIndicador = r.data.object; });
    },
    carregarOkr(idokr) {
      this.progress = true;
      this.$clubApi.get("/okr/" + idokr).then((r) => {
        let okrData = r.data.object;

        if (!this.podeEditar()) {
          this.$toastr.error("Apenas usuários ADMIN podem alterar dados do Objetivo.");
          location.href = '/okr';
          return;
        }

        this.okr.idokr       = okrData.idokr;
        this.okr.descricao   = okrData.descricao;
        this.okr.dataFim     = okrData.dataFim;
        this.okr.tipo        = okrData.tipo;
        this.okr.situacao    = okrData.situacao;
        this.okr.idgt        = okrData.idgt || (okrData.grupoTrabalho ? okrData.grupoTrabalho.idgt : null);
        this.okr.grupoTrabalho = okrData.grupoTrabalho || (okrData.listaGrupoTrabalho && okrData.listaGrupoTrabalho.length > 0 ? okrData.listaGrupoTrabalho[0] : null);
        this.okr.listaResp   = okrData.listaResponsavel || [];
        this.okr.listaProjeto = okrData.listaProjeto || [];
        this.okr.listaIndicador = (okrData.listaIndicador || []).map(ind => ({
          idindicador: ind.idindicador,
          codigo:      ind.codigo,
          descricao:   ind.descricao,
          baseline:    ind.baseline,
          meta:        ind.meta,
          tipoIndicador: ind.tipoIndicador || "",
          sentido:       ind.sentido || "",
          fonte:         ind.fonte || "",
          formaCalculo:  ind.formaCalculo || "",
          situacao:      ind.situacao || 'NAO_INICIADO',
        }));
      }).catch((e) => {
        this.$toastr.error("Erro ao carregar Objetivo.");
        location.href = '/okr';
      }).finally(() => { this.progress = false; });
    },
    podeEditar() {
      return this.perfilAdmin;
    },

    // ---- GRUPO DE TRABALHO ----
    getEndpointGT() {
      if (this.perfilNome === "ADMIN") return "/estrutura/gt/ativo";
      if (this.perfilNome === "COORDENADOR") {
        return this.idCoordenacao ? `/estrutura/gt/${this.idCoordenacao}` : "/estrutura/gt/ativo";
      }
      return "/estrutura/gt/nome/true"; // COLABORADOR e demais
    },
    addGrupoTrabalho() {
      this.addGTNome = "";
      if (this.listaAddGTFiltro.length === 0) {
        this.listaAddGT = [];
        this.progressGT = true;
        this.$clubApi.get(this.getEndpointGT()).then((response) => {
          this.listaAddGT = response.data.object || [];
          this.listaAddGTFiltro = response.data.object || [];
          this.modals.modalGT = true;
        }).catch((e) => {
          this.$toastr.error((e.response && e.response.data && e.response.data.msg) || "Erro ao carregar grupos de trabalho.");
        }).finally(() => {
          this.progressGT = false;
        });
      } else {
        this.listaAddGT = this.listaAddGTFiltro;
        this.modals.modalGT = true;
      }
    },
    pesquisarGT() {
      if (!this.addGTNome) {
        this.listaAddGT = this.listaAddGTFiltro;
      } else {
        let filtro = this.addGTNome.toUpperCase();
        this.listaAddGT = this.listaAddGTFiltro.filter((gt) => {
          return (gt.nome && gt.nome.toUpperCase().indexOf(filtro) >= 0)
            || (gt.nomeComCoord && gt.nomeComCoord.toUpperCase().indexOf(filtro) >= 0)
            || (gt.coordenacao && gt.coordenacao.sigla && gt.coordenacao.sigla.toUpperCase().indexOf(filtro) >= 0);
        });
      }
    },
    selecionarGT(gt) {
      const gtAnterior = this.okr.idgt;
      const houveTroca = gtAnterior && gtAnterior !== gt.idgt;

      this.okr.idgt = gt.idgt;
      this.okr.grupoTrabalho = gt;

      if (houveTroca) {
        this.okr.listaResp = [];
        this.okr.listaProjeto = [];
        this.listaAddResp = [];
        this.listaAddRespFiltro = [];
        this.listaAddProj = [];
        this.listaAddProjFiltro = [];
        this.addRespNome = "";
        this.addProjNome = "";
      }

      this.modals.modalGT = false;
      this.$toastr.success("Grupo de Trabalho selecionado!");
    },
    fecharModalGT() {
      this.addGTNome = "";
      this.modals.modalGT = false;
    },

    // ---- INDICADORES ----
    addIndicador() {
      this.indicadorEdicao = { idx: null, descricao: "", baseline: null, meta: null, tipoIndicador: "", sentido: "", fonte: "", formaCalculo: "", situacao: 'NAO_INICIADO' };
      this.modals.modalIndicador = true;
      this.$nextTick(() => {
        if (this.$refs.indDescricaoInput) this.$refs.indDescricaoInput.focus();
      });
    },
    editarIndicador(idx) {
      let ind = this.okr.listaIndicador[idx];
      // Não permite editar indicadores já cadastrados no banco
      if (ind.idindicador) {
        this.$toastr.warning("Indicadores já cadastrados não podem ser alterados aqui.");
        return;
      }
      this.indicadorEdicao = { idx, descricao: ind.descricao, baseline: ind.baseline, meta: ind.meta,
        tipoIndicador: ind.tipoIndicador || "", sentido: ind.sentido || "", fonte: ind.fonte || "",
        formaCalculo: ind.formaCalculo || "",
        situacao: ind.situacao || 'NAO_INICIADO' };
      this.modals.modalIndicador = true;
      this.$nextTick(() => {
        if (this.$refs.indDescricaoInput) this.$refs.indDescricaoInput.focus();
      });
    },
    confirmarIndicador() {
      if (!this.indicadorEdicao.descricao)   { this.$toastr.error("Título do indicador é obrigatória!"); return; }
      if (this.indicadorEdicao.baseline === null || this.indicadorEdicao.baseline === undefined || this.indicadorEdicao.baseline === '') { this.$toastr.error("Baseline do indicador é obrigatória!"); return; }
      if (this.indicadorEdicao.meta === null || this.indicadorEdicao.meta === undefined || this.indicadorEdicao.meta === '') { this.$toastr.error("Meta do indicador é obrigatória!"); return; }
      if (!this.indicadorEdicao.tipoIndicador) { this.$toastr.error("Tipo do indicador é obrigatório!"); return; }
      if (!this.indicadorEdicao.sentido)     { this.$toastr.error("Sentido do indicador é obrigatório!"); return; }
      if ((this.indicadorEdicao.formaCalculo || '').length > 4000) { this.$toastr.error("Forma de Cálculo deve ter no máximo 4000 caracteres."); return; }

      let baselineVal = parseFloat(this.indicadorEdicao.baseline) || 0;
      let metaVal = parseFloat(this.indicadorEdicao.meta);

      // Validação de meta != baseline (não faz sentido meta = baseline)
      if (metaVal === baselineVal) {
        this.$toastr.error("O valor da Meta deve ser diferente do valor da Baseline!");
        return;
      }

      let item = {
        idindicador:   null,
        descricao:     this.indicadorEdicao.descricao,
        baseline:      this.indicadorEdicao.baseline,
        meta:          this.indicadorEdicao.meta,
        tipoIndicador: this.indicadorEdicao.tipoIndicador,
        sentido:       this.indicadorEdicao.sentido,
        fonte:         this.indicadorEdicao.fonte,
        formaCalculo:  this.indicadorEdicao.formaCalculo,
        situacao:      this.indicadorEdicao.situacao || 'NAO_INICIADO',
      };
      if (this.indicadorEdicao.idx !== null) {
        item.idindicador = this.okr.listaIndicador[this.indicadorEdicao.idx].idindicador;
        this.$set(this.okr.listaIndicador, this.indicadorEdicao.idx, item);
        this.$toastr.success("Indicador atualizado!");
      } else {
        this.okr.listaIndicador.push(item);
        this.$toastr.success("Indicador adicionado!");
      }
      this.modals.modalIndicador = false;
    },
    retirarIndicador(idx) {
      let ind = this.okr.listaIndicador[idx];
      // Não permite remover indicadores já cadastrados no banco
      if (ind.idindicador) {
        this.$toastr.warning("Indicadores já cadastrados não podem ser removidos aqui.");
        return;
      }
      const options = { title: "Remover Indicador", okLabel: "Sim", cancelLabel: "Não" };
      this.$dialogs.confirm("Deseja realmente remover o indicador?", options).then((res) => {
        if (res.ok) {
          this.okr.listaIndicador.splice(idx, 1);
          this.$toastr.success("Indicador removido!");
        }
      });
    },
    fecharModalIndicador() {
      this.modals.modalIndicador = false;
    },

    // ---- RESPONSÁVEIS ----
    addResponsavel() {
      if (!this.okr.idgt) {
        this.$toastr.error("Selecione um Grupo de Trabalho antes de adicionar responsáveis.");
        return;
      }
      this.addRespNome = "";
      if (this.listaAddRespFiltro.length === 0) {
        this.listaAddResp = [];
        let objConsulta = { grupoTrabalho: [{ idgt: this.okr.idgt }] };
        this.progress = true;
        this.$clubApi.post("/user/nome/", objConsulta).then((response) => {
          this.listaAddResp = response.data.object;
          this.listaAddRespFiltro = response.data.object;
          this.modals.modalResp = true;
        }).catch((e) => {
          this.$toastr.error((e.response && e.response.data && e.response.data.msg) || "Erro ao carregar usuários.");
        }).finally(() => { this.progress = false; });
      } else {
        this.listaAddResp = this.listaAddRespFiltro;
        this.modals.modalResp = true;
      }
    },
    pesquisarResp() {
      if (!this.addRespNome) {
        this.listaAddResp = this.listaAddRespFiltro;
      } else {
        let filtro = this.addRespNome.toUpperCase();
        this.listaAddResp = this.listaAddRespFiltro.filter((u) =>
          (u.nome && u.nome.toUpperCase().indexOf(filtro) >= 0) ||
          (u.apelido && u.apelido.toUpperCase().indexOf(filtro) >= 0)
        );
      }
    },
    adicionarResp(resp) {
      let jaAdicionado = this.okr.listaResp.some(r => r.idusuario === resp.idusuario);
      if (jaAdicionado) { this.$toastr.error("Responsável já adicionado!"); return; }
      this.okr.listaResp.push(resp);
      this.modals.modalResp = false;
      this.$toastr.success("Responsável adicionado!");
    },
    retirarResp(idusuario) {
      this.okr.listaResp = this.okr.listaResp.filter(r => r.idusuario !== idusuario);
      this.$toastr.success("Responsável removido!");
    },
    fecharModalResp() {
      this.addRespNome = "";
      this.modals.modalResp = false;
    },

    // ---- PROJETOS ----
    addProjeto() {
      if (!this.okr.idgt) {
        this.$toastr.error("Selecione um Grupo de Trabalho antes de adicionar projetos.");
        return;
      }
      this.addProjNome = "";
      this.listaAddProj = [];
      this.listaAddProjFiltro = [];
      this.modals.modalProjeto = true;
      this.$nextTick(() => { if (this.$refs.addProjNomeInput) this.$refs.addProjNomeInput.focus(); });
    },
    pesquisarProjeto() {
      if (this.timeoutProj) clearTimeout(this.timeoutProj);
      if (!this.okr.idgt) {
        this.listaAddProj = [];
        this.listaAddProjFiltro = [];
        return;
      }
      if (!this.addProjNome || this.addProjNome.length < 3) {
        this.listaAddProj = [];
        this.listaAddProjFiltro = [];
        return;
      }
      this.timeoutProj = setTimeout(() => {
        this.progressVinculoProjeto = true;
        this.$clubApi.post("/projeto/lista", { nome: this.addProjNome, idgt: this.okr.idgt }).then((response) => {
          this.listaAddProj = response.data.object;
          this.listaAddProjFiltro = response.data.object;
        }).catch((e) => {
          this.$toastr.error("Erro ao pesquisar projetos.");
        }).finally(() => { this.progressVinculoProjeto = false; });
      }, 500);
    },
    adicionarProjeto(proj) {
      if (!this.okr.listaProjeto) this.okr.listaProjeto = [];
      let jaAdicionado = this.okr.listaProjeto.some(p => p.idprojeto === proj.idprojeto);
      if (jaAdicionado) { this.$toastr.error("Projeto já vinculado a esse objetivo"); return; }
      this.okr.listaProjeto.push(proj);
      this.$toastr.success("Projeto vinculado!");
      // Limpa o campo para nova pesquisa, mantendo a modal aberta
      this.addProjNome = "";
      this.listaAddProj = [];
      this.listaAddProjFiltro = [];
    },
    retirarProjeto(idprojeto) {
      this.okr.listaProjeto = this.okr.listaProjeto.filter(p => p.idprojeto !== idprojeto);
      this.$toastr.success("Projeto desvinculado!");
    },
    fecharModalProjeto() {
      this.addProjNome = "";
      this.modals.modalProjeto = false;
    },

    // ---- NAVEGAÇÃO ----
    tipoIndicadorLabel(codigo) {
      const found = this.listaTipoIndicador.find(t => t.codigo === codigo);
      return found ? found.descricao : codigo;
    },
    mascaraKr(okr, idx) {
      const okrPad = okr && okr.idokr ? String(okr.idokr).padStart(3, '0') : '000';
      const krPad = String((idx || 0) + 1).padStart(2, '0');
      return (okrPad === '000') ? `KR-${krPad}` : `KR-${okrPad}.${krPad}`;
    },
    proximo() {
      if (this.current === 0) { this.validaDadosGerais(); return; }
      if (this.current === 1) { this.validaIndicadores(); return; }
      if (this.current === 2) { this.validaGrupoTrabalho(); return; }
      if (this.current === 3) { this.validaResponsaveis(); return; }
      if (this.current === 4) { this.validaProjetos(); return; }
      this.current++;
    },
    anterior() { this.current--; },
    voltar() {
      const options = { title: "Cancelar", okLabel: "Confirmar", cancelLabel: "Não" };
      this.$dialogs.confirm("Deseja realmente desistir do cadastro do Objetivo?", options)
        .then((res) => { if (res.ok) location.href = '/okr'; });
    },

    // ---- VALIDAÇÕES ----
    validaDadosGerais() {
      if (!this.okr.descricao) { this.$toastr.error("Título obrigatório!"); return; }
      if (!this.okr.tipo)      { this.$toastr.error("Tipo obrigatório!"); return; }
      if (!this.okr.dataFim)   { this.$toastr.error("Data Fim obrigatória!"); return; }
      // Validar que a data fim é posterior a hoje
      var partes = this.okr.dataFim.split('/');
      var dataFimDate = new Date(partes[2], partes[1] - 1, partes[0]);
      var hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      if (dataFimDate <= hoje) {
        this.$toastr.error("Data Fim deve ser maior que a data de hoje!");
        return;
      }
      this.current++;
    },
    validaIndicadores() {
      if (!this.okr.listaIndicador || this.okr.listaIndicador.length === 0) {
        this.$toastr.error("Adicione ao menos um Indicador/KR!");
        return;
      }
      this.current++;
    },
    validaGrupoTrabalho() {
      if (!this.okr.idgt) {
        this.$toastr.error("Selecione um Grupo de Trabalho!");
        return;
      }
      this.current++;
    },
    validaResponsaveis() {
      if (!this.okr.listaResp || this.okr.listaResp.length === 0) {
        this.$toastr.error("Informe pelo menos um responsável!");
        return;
      }
      this.current++;
    },
    validaProjetos() {
      // Opcional, avança direto
      this.current++;
    },

    // ---- SALVAR ----
    salvarOkr() {
      if (this.okr.idokr && !this.podeEditar()) {
        this.$toastr.error("Apenas usuários ADMIN podem alterar dados do Objetivo.");
        return;
      }
      const options = { title: "Confirmação", okLabel: "Confirmar", cancelLabel: "Não" };
      let acao    = this.okr.idokr ? "alterar" : "cadastrar";
      let resposta = this.okr.idokr ? "alterado" : "cadastrado";
      this.$dialogs.confirm(`Deseja ${acao} o Objetivo?`, options).then((res) => {
        if (!res.ok) return;
        this.progress = true;
        
        // Ao editar, enviar apenas indicadores novos (sem idindicador)
        let listaIndicadorPayload = this.okr.idokr
          ? this.okr.listaIndicador.filter(ind => !ind.idindicador)
          : this.okr.listaIndicador;
        
        let payload = {
          idokr:          this.okr.idokr,
          descricao:      this.okr.descricao,
          dataFim:        this.okr.dataFim,
          tipo:           this.okr.tipo,
          situacao:       this.okr.situacao || null,
          idgt:           this.okr.idgt,
          listaResp:      this.okr.listaResp.map(r => ({ idusuario: r.idusuario })),
          listaIndicador: listaIndicadorPayload,
          listaIdProjeto: this.okr.listaProjeto ? this.okr.listaProjeto.map(p => p.idprojeto) : [],
        };
        let url    = this.okr.idokr ? `/okr/${this.okr.idokr}` : "/okr";
        let method = this.okr.idokr ? "put" : "post";
        this.$clubApi[method](url, payload).then(() => {
          this.$toastr.success(`Objetivo ${resposta} com sucesso!`);
          setTimeout(() => { location.href = '/okr'; }, 1500);
        }).catch((e) => {
          this.progress = false;
          this.$toastr.error((e.response && e.response.data && e.response.data.msg) || "Erro ao salvar Objetivo.");
        });
      });
    },
  },
};
</script>

<style>
.opcao { color: #c0c0c0; cursor: pointer; }
.opcao:hover { color: red; cursor: pointer; }
.listaGT { align-items: flex-start; display: flex; margin-bottom: 4px; padding: 6px 4px; min-height: 40px; }
.listaGT:hover { background-color: #edebfe; cursor: pointer; }
.listaGT:hover .opcao { visibility: visible; opacity: 1; }
.gtInfo { display: flex; width: 100%; justify-content: space-between; align-items: center; }
.steps-action { margin-top: 24px; }
</style>
